module.exports = __webpack_public_path__ + "static/media/industrial-design.b1fe958c.jpg";